import { render, staticRenderFns } from "./DropDownSort.vue?vue&type=template&id=af2bed44"
import script from "./DropDownSort.vue?vue&type=script&lang=js"
export * from "./DropDownSort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports